import * as React from 'react'
import { tableStyles } from '../../../../utils/uiTokens'
import { useIntl } from 'react-intl'
import { TableHead } from '@mui/material'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { VideoWatcherState } from '../../../../features/types'
import { toMinutesAndSeconds } from '../../../../utils/functions'

interface Props {
    watchers: VideoWatcherState[]
    isFetching: boolean
}

const COL_SPAN = 7

const VideoWatchersTable: React.FC<Props> = ({
    watchers = [],
    isFetching,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Box>
            <TableContainer
                component={Paper}
                sx={tableStyles.container}
                elevation={0}
            >
                <Table sx={{ minWidth: 500 }}>
                    <TableHead sx={tableStyles.head}>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>{formatMessage({ id: 'fullName' })}</TableCell>
                            <TableCell>{formatMessage({ id: 'group' })}</TableCell>
                            <TableCell align="center">
                                {formatMessage({ id: 'kinescopeWatchTime' })}
                            </TableCell>
                            <TableCell align="center">
                                {formatMessage({ id: 'kinescopeViews' })}
                            </TableCell>
                            <TableCell align="center">
                                {formatMessage({ id: 'kinescopePlays' })}
                            </TableCell>
                            <TableCell align="center">
                                {formatMessage({ id: 'percentWatched' })}
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    {watchers.length ? (
                        <TableBody>
                            {watchers.map((row, index) => (
                                <TableRow key={row.studentId} sx={tableStyles.row}>
                                    <TableCell>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell>
                                        {row.firstName} {row.lastName}
                                    </TableCell>
                                    <TableCell>{row.groupTitle}</TableCell>
                                    <TableCell align="center">
                                        {toMinutesAndSeconds(row.metrics?.watchTime || 0)}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.metrics?.view || 0}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.metrics?.play || 0}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.percentage || 0}%
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    ) : (
                        !isFetching && (
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={COL_SPAN}>
                                        {formatMessage({ id: 'noData' })}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )
                    )}

                </Table>
            </TableContainer>
        </Box>
    )
}

export default VideoWatchersTable
